import { ApiResponse, TokenData, DiscountType, DiscountMode } from '../models';
import * as http from './http';
import ApiService from './service';

export class CashDiscountTypeService extends ApiService {
  public async loadDiscountType(mode?: string) {
    const url = `${this.apiDomain}/api/discount/type/cash`;

    const resposne = await http.get<ApiResponse<DiscountType[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async updateDiscountType(data: DiscountType, id?: string) {
    const url = `${this.apiDomain}/api/discount/type/cash/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async createDiscountType(data: DiscountType) {
    const url = `${this.apiDomain}/api/discount/type/cash`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async deleteDiscountType(id?: string) {
    const url = `${this.apiDomain}/api/discount/type/cash/${id}`;

    const response = await http.remove<ApiResponse<DiscountType>>(
      url,
      this.store
    );
    return response.data;
  }
  public async updateonModelVariants(
    modelVariants: { modelCode: string; variantCode: string }[],
    id?: string
  ) {
    const url = `${this.apiDomain}/api/discount/type/cash/${id}/model-variants`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      { modelVariants },
      this.store
    );
    return response.data;
  }
  public async getExclusiveCashDiscountTypes(id: string) {
    const url = `${this.apiDomain}/api/discount/type/cash/${id}/exclusive`;

    const resposne = await http.get<
      ApiResponse<{ discountTypeId: string; discountMode: string }[]>
    >(url, this.store);
    return resposne?.data?.data;
  }

  public async createDiscountTypeExclusive(
    id: string,
    discountTypeId: string,
    discountMode: DiscountMode
  ) {
    const url = `${this.apiDomain}/api/discount/type/cash/${id}/exclusive`;

    const response = await http.post<ApiResponse<string[]>>(
      url,
      {
        discountTypeId,
        discountMode,
      },
      this.store
    );
    return response.data;
  }

  public async deleteExclusive(
    id: string,
    discountTypeId: string,
    discountMode: DiscountMode
  ) {
    const url = `${this.apiDomain}/api/discount/type/cash/${id}/exclusive/${discountTypeId}/${discountMode}`;

    const response = await http.remove<ApiResponse<string[]>>(url, this.store);
    return response.data;
  }

  public async getCombinedCashDiscountTypes(id: string) {
    const url = `${this.apiDomain}/api/discount/type/cash/${id}/combined`;

    const resposne = await http.get<
      ApiResponse<{ discountTypeId: string; discountMode: string }[]>
    >(url, this.store);
    return resposne?.data?.data;
  }

  public async createDiscountTypeCombined(
    id: string,
    discountTypeId: string,
    discountMode: DiscountMode
  ) {
    const url = `${this.apiDomain}/api/discount/type/cash/${id}/combined`;

    const response = await http.post<ApiResponse<string[]>>(
      url,
      {
        discountTypeId,
        discountMode,
      },
      this.store
    );
    return response.data;
  }

  public async deleteCombined(
    id: string,
    discountTypeId: string,
    discountMode: DiscountMode
  ) {
    const url = `${this.apiDomain}/api/discount/type/cash/${id}/combined/${discountTypeId}/${discountMode}`;

    const response = await http.remove<ApiResponse<string[]>>(url, this.store);
    return response.data;
  }
}
